<template>
  <div class="sidebar-wrapper" ref="wrapper" :class="{show}">
    <slot></slot>
  </div>
</template>

<script>

import {computed} from "@vue/composition-api";

export default {
  name: "SideBar",
  props: {
    sideBarId: String
  },
  setup(props, {root}){
    const show = computed(() => {
      return root.$selectedSidebar.value === props.sideBarId
    })
    return {show}
  }
}
</script>

<style scoped lang="scss">
.sidebar-wrapper {
  position: fixed;
  right: 0;
  top: 64px;
  z-index: 2000;
  background-color: $white;
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.16);
  transform: translate(100%);
  transition: 0.2s;
  width: 100%;
  max-width: 350px;
  height: calc(100vh - 64px);
  overflow-y: auto;

  &.show {
    transform: translate(0);
  }
}
</style>
